/**
 * Professional scroll-triggered animations for hhm-team block.
 * Adds hhm-team-inview when section enters viewport to trigger CSS transitions.
 */
( function () {
	function init() {
		const section = document.querySelector( '.hhm-team-animate' );
		if ( ! section || section.getAttribute( 'data-team-animated' ) === '1' ) {
			return;
		}

		const observer = new IntersectionObserver(
			function ( entries ) {
				entries.forEach( function ( entry ) {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( 'hhm-team-inview' );
						entry.target.setAttribute( 'data-team-animated', '1' );
						observer.unobserve( entry.target );
					}
				} );
			},
			{
				rootMargin: '0px 0px -40px 0px',
				threshold: 0.1,
			}
		);

		observer.observe( section );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
